import {h, Fragment} from "preact"
import { useResponse, AutocompleteElement, Keywords, useCurrencyFormatting, useAppStateSelector, pick } from "@nosto/preact"
import { productImagePlaceholder } from "../helpers"
import SubmitButton from "./elements/SubmitButton"
import DropdownProduct from "./DropdownProduct"
import {suggestedCollections} from "../config"
import CollectionImagePlaceholder from "./elements/CollectionImagePlaceholder"
import { useEffect } from "preact/hooks"

export default function Autocomplete() {
    const { products, keywords } = useResponse();
    const { format } = useCurrencyFormatting();
    const { query } = useAppStateSelector(state =>
        pick(state, "query")
    )

    if (!products?.hits?.length && !keywords?.hits?.length) {
        return
    }
    
    useEffect(() => {
        if(!window.Nosto?.migrateToShopifyMarket) return;
        window.Nosto.migrateToShopifyMarket({
            productSectionElement: '.ns-autocomplete .ns-markets',
            productHandleAttribute: 'data-handle',
            productUrlElement: '.ns-autocomplete .product-card__link',
            priceElement: '.ns-autocomplete .ns-price',
            listPriceElement: '.ns-autocomplete .ns-list-price',
        })
    }, [ products?.hits ])

    return (
        <div
            class="ns-autocomplete ns-fixed ns-d-flex ns-flex-column ns-flex-sm-row ns-align-items-start ns-background-white ns-border-box ns-mx-auto"
            data-nosto-element="autocomplete"
        >
            <div class="ns-w-100 ns-autocomplete-container">
                <div class="ns-d-flex ns-flex-column ns-flex-l-row">
                    <div class="ns-autocomplete-left-part">
                        {keywords?.hits?.length > 0 && (
                            <div
                            // ns-col-12 ${
                            //     products?.hits?.length > 0 ? "ns-col-sm-4" : "ns-col-sm-12"
                            // }
                                class={`ns-autocomplete-keywords ns-d-flex ns-flex-column`}
                            >
                                {/* ns-py-2 ns-px-4 */}
                                <div class="ns-color-black ns-autocomplete-heading">
                                    Popular Searches
                                </div>
                                <div class="ns-d-flex ns-flex-column">
                                    <Keywords
                                        hits={keywords.hits}
                                        keywordComponent={Keyword}
                                        elementComponent={Element}
                                        keywordInCategoryComponent={KeywordInCategory}
                                    />
                                </div>
                                {/* {!products?.hits?.length && <SubmitButton text="See all search results" />} */}
                            </div>
                        )}
                        <div class="predictive-search__row">
                            <h6 class="search-drawer__title">Collections</h6>
                            <ul class="predictive-search__links predictive-search__collections list-unstyled">
                                {suggestedCollections?.map(collection => {
                                    return (
                                        <li class="predictive-search__links-item">
                                            <a href={collection?.url} class="predictive-search__collections-box">
                                                {/* <div class="predictive-search__collections-img">
                                                    <div class="media">
                                                        {collection?.image ? (
                                                            <img src={`${collection?.image}&width=128`} alt="" width="3600" height="3600" srcSet={`${collection?.image}&width=360 360w, ${collection?.image}&width=480 480w, ${collection?.image}&width=600 600w, ${collection?.image}&width=720 720w, ${collection?.image}&width=840 840w, ${collection?.image}&width=960 960w, ${collection?.image}&width=1280 1280w, ${collection?.image}&width=1440 1440w, ${collection?.image}&width=1800 1800w, ${collection?.image}&width=2160 2160w, ${collection?.image}&width=2880 2880w, ${collection?.image} 3600w`} sizes="(max-width: 360px) 360px,(max-width: 480px) 480px,(max-width: 600px) 600px,(max-width: 720px) 720px,(max-width: 840px) 840px,(max-width: 960px) 960px,(max-width: 1280px) 1280px,(max-width: 1440px) 1440px,(max-width: 1800px) 1800px,(max-width: 2160px) 2160px,(max-width: 2880px) 2880px,(max-width: 3600px) 3600px, 100vw" />
                                                        ) : (
                                                            <CollectionImagePlaceholder />
                                                        )}
                                                    </div>
                                                </div> */}
                                                <div class="predictive-search__collections-title">
                                                    <span>{collection?.title}</span>
                                                </div>
                                            </a>
                                        </li>
                                    )
                                })}
                            </ul>
                        </div>
                    </div>
                    {products?.hits?.length > 0 && (
                        // ns-flex-grow-1
                        <div class="ns-autocomplete-products ns-d-flex ns-flex-column">
                            {/* ns-py-2 ns-px-4 */}
                            <div class="ns-color-black ns-autocomplete-heading">
                                Products
                            </div>
                            <div class="ns-d-flex ns-autocomplete-products-container">
                                {products?.hits?.map(hit => {
                                    return (
                                        <DropdownProduct key={hit.productId} product={hit} />
                                    )
                                })}
                            </div>
                        </div>
                    )}
                </div>
                <SubmitButton text={`View results for "${query?.query}"`} className="predictive-search__row" />                    
            </div>
        </div>
    )
}

function Keyword({ hit }) {
    return (
        <span data-nosto-element="keyword">
            {hit?._highlight?.keyword ? (
                <span
                    dangerouslySetInnerHTML={{
                        __html: hit._highlight.keyword
                    }}
                ></span>
            ) : (
                hit.keyword
            )}
        </span>
    )
}

function Element({ hit, keywordComponent, filter }) {
    return (
        // ns-py-2 ns-px-4
        <AutocompleteElement hit={hit} filter={filter} class="ns-clickable ns-font-4">
            {keywordComponent}
        </AutocompleteElement>
    )
}

function KeywordInCategory({ category, children }) {
    return (
        <span class="ns-clickable">
            {category?.value ? (
                <span>
                    {children}{" "}
                    <span class="ns-keyword-in-category">
                        in <span>{category.value}</span>
                    </span>
                </span>
            ) : (
                children
            )}
        </span>
    )
}